import React from 'react';

const Steps = () => {
  return (
    <div className="section steps">
      <div className="container">
        <div className="steps_grid">
          <div className="steps_grid-item -title">
            <div className="steps_title-section">
              <h2 className="section_title steps_title color-red">
                Open your
                <br />
                savings account
                <br />
                in just 5 minutes
              </h2>
              <div className="steps_button">
                <button className="button -red">Get started</button>
              </div>
            </div>
          </div>

          <div className="steps_grid-item -steps">

            <div className="steps_grid-decoration -not-mobile">
              <div className="decor-squares -vertical -red" />
            </div>
            <div className="steps_grid-decoration -mobile">
              <div className="decor-squares -red -sm -center -bolder-vertical" />
            </div>

            <div className="steps_grid-inner">
              <div className="steps_grid-inner-item">
                <div className="steps_plate">
                  <div className="steps_plate-number color-red">
                    1
                  </div>
                  <div className="steps_plate-details">
                    <h3 className="steps_plate-title">
                      Enter your info
                    </h3>
                    <div className="steps_plate-text">
                      Follow the link to get started and complete the application.
                    </div>
                  </div>
                </div>
              </div>
              <div className="steps_grid-inner-item">
                <div className="steps_plate">
                  <div className="steps_plate-number color-red">
                    2
                  </div>
                  <div className="steps_plate-details">
                    <h3 className="steps_plate-title">
                      Download the app
                    </h3>
                    <div className="steps_plate-text">
                      After applying, download the Openbank app and sign in.
                    </div>
                  </div>
                </div>
              </div>
              <div className="steps_grid-inner-item">
                <div className="steps_plate">
                  <div className="steps_plate-number color-red">
                    3
                  </div>
                  <div className="steps_plate-details">
                    <h3 className="steps_plate-title">
                      Drop your money in
                    </h3>
                    <div className="steps_plate-text">
                      Deposit and maintain a minimum balance of $1,000 to earn
                      {' '}
                      Verizon bill credits for the first 12 months.
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Steps;
